import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { API } from "@/lib/api";

export default function SmartLinkRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/smart/resolve/${code}`);
        navigate(data.redirect, { replace: true });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
  }, [code, navigate]);
  return (
    <div className="min-h-[100dvh] flex items-center justify-center" style={{ background: "#0B0D12" }} data-testid="smart-redirect">
      <Loader2 className="w-6 h-6 animate-spin text-white/50" />
    </div>
  );
}
